import { render } from "./CrossLabRegisteredCases.vue?vue&type=template&id=05ba3a5e"
import script from "./CrossLabRegisteredCases.vue?vue&type=script&lang=js"
export * from "./CrossLabRegisteredCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/CrossLabRegisteredCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05ba3a5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05ba3a5e', __exports__)) {
    console.log('reload')
    api.reload('05ba3a5e', __exports__)
  }
  
  module.hot.accept("./CrossLabRegisteredCases.vue?vue&type=template&id=05ba3a5e", () => {
    console.log('re-render')
    api.rerender('05ba3a5e', render)
  })

}


export default __exports__